import SEO from '@/components/shared/SEO'
import Reviews from '@/components/Reviews'
import KeyInformation from '@/components/KeyInformation'
import USPBanner from '@/components/USPBanner'
import ClaimProcessSteps from '@/components/shared/ClaimProcessSteps'
import LenderClaimExplanation from '@/components/shared/LenderClaimExplanation'
import LenderFactsSection from '@/components/shared/LenderFactsSection'
import LenderClaimSteps from '@/components/shared/LenderClaimSteps'
import LenderLinksSection from '@/components/shared/LenderLinksSection'
import VehicleLinksSection from '@/components/shared/VehicleLinksSection'
import LenderHeroSection from '@/components/shared/LenderHeroSection'
import FAQ from '@/components/FAQ'
import { useFaqs } from '@/hooks/useFaqs'

const LenderPageTemplate = ({
  lenderName,
  slug,
  seoImage = '',
  seoImageAlt = '',
  _aiOverview = '',
}) => {
  const { faqs } = useFaqs(5)
  return (
    <main className="flex-1">
      <SEO
        title={`Claim for Mis-Sold ${lenderName} Car Finance – Check Eligibility in 60 Seconds`}
        description={`Were you mis-sold a ${lenderName} car finance agreement? You could be owed compensation. Use our free compensation checker to see if you're eligible in just 60 seconds.`}
        keywords={`${lenderName} finance claim, mis-sold car finance, ${lenderName} refund, ${lenderName} compensation, car finance claim UK, PCP mis-selling, Hire Purchase mis-selling, FCA car finance compensation, ${lenderName} mis-selling`}
        url={slug}
        image={seoImage || '/Image/Car-photo-illustration-claims1.webp'}
        imageAlt={seoImageAlt || `${lenderName} car finance claims`}
        schemaType="WebPage"
        schemaData={{
          mainEntity: {
            '@type': 'Service',
            name: `${lenderName} Car Finance Claim Service`,
            description: `Professional car finance mis-selling claims service for ${lenderName} customers`,
            provider: {
              '@type': 'Organization',
              name: 'Your Claim Matters',
              url: 'https://yourclaimmatters.co.uk',
            },
            areaServed: 'United Kingdom',
            serviceType: 'Legal Services',
          },
        }}
        breadcrumbs={[
          { name: 'Home', url: '/' },
          { name: 'Lenders', url: '/lenders' },
          { name: `${lenderName} Claims`, url: slug },
        ]}
      />

      <USPBanner />

      {/* Hero Section */}
      <LenderHeroSection lenderName={lenderName} />

      {/* Body Section */}
      <LenderClaimExplanation lenderName={lenderName} />

      {/* Facts Section */}
      <LenderFactsSection lenderName={lenderName} />

      {/* Process Section */}
      <LenderClaimSteps lenderName={lenderName} />

      {/* What Happens Section */}
      <ClaimProcessSteps lenderName={lenderName} />

      {/* Vehicle Makes Section */}
      <VehicleLinksSection />

      {/* Lenders Section */}
      <LenderLinksSection />

      {/* Reviews Section */}
      <Reviews />

      {/* FAQ Section */}
      <FAQ faqs={faqs} includeStructuredData={false} />

      {/* Key Facts Section */}
      <KeyInformation />
    </main>
  )
}

export default LenderPageTemplate
